#import "../fragments/mailChimpList-basic.graphql"

query MailChimpListsQuery {
    mailChimpLists {
        ...MailChimpListBasic
    }
}
